/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-03-02 09:37:28
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2022-06-12 15:10:15
 * @FilePath: \baishu_react_ui\src\components\BsyAlertQYWorkConfig\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react'
import ReactDOM from 'react-dom'
import AlertList from './Staticize'
import {BsyUtils} from "../../utils/Utils";

const BsyAlertQYWorkConfig = props =>
    new Promise((fulfill) => { // 此处参数需用圆括号，否则 eslint 报错
        let holder
        let rootTokenClass = 'rootTokenCls'+ (new Date()).getTime()
        if(document.getElementsByClassName("BsyAlertQYWorkConfig").length>0){
            document.getElementsByClassName("BsyAlertQYWorkConfig")[0].removeChild(document.getElementsByClassName("BsyAlertQYWorkConfig")[0].firstChild);
            holder = document.getElementsByClassName("BsyAlertQYWorkConfig")[0]
        }else{
            holder = document.createElement('div');
            holder.style.zIndex = window.FX.STATIC.zIndex++
            holder.classList.add("BsyAlertQYWorkConfig");
            holder.classList.add(rootTokenClass);
            setTimeout(()=>{
                holder.classList.add("fadein");
            },30)
            document.body.appendChild(holder)
        }
        let CleanRootNode = (e)=>{
            // 当界面被点击时自动清理元素
            // e 为null，组件自己清理自己
            // 无法找到父级元素 rootTokenClass 说明点击了其他任意位置
            if(!e || !BsyUtils.closestClass(e.target,rootTokenClass)) {

                ReactDOM.unmountComponentAtNode(holder)
                holder.remove();
                document.removeEventListener('mouseup', CleanRootNode, false);
            }
        }
        let holderTo = document.createElement('div');
        holderTo.classList.add("alertQYWorkConfigContent");
        holder.onclick = (event) =>{
            event.stopPropagation()
        }
        holder.appendChild(holderTo)

        // let timer = setTimeout(()=>{
        //     holder.removeChild(holderTo)
        //     ReactDOM.unmountComponentAtNode(holderTo)
        //     if(document.getElementsByClassName("alertImgCodeContent").length<=0){
        //         document.body.removeChild(holder)
        //         ReactDOM.unmountComponentAtNode(holder)
        //     }
        //     clearInterval(timer)
        // },3000)

        if(document.getElementsByClassName("alertQYWorkConfigContent").length>1){
            holder.removeChild(holderTo)
            ReactDOM.unmountComponentAtNode(holderTo)
            // clearInterval(timer)
        }
        const newProps={...props,target:holderTo}
        newProps.onRemoveRoot = ()=>{
            //自动清理
            holder.classList.remove("fadein");
            setTimeout(()=>{
                CleanRootNode();
            },218)
        }
        ReactDOM.render(
            <AlertList
                {...newProps}
            />,
            holderTo
        )
    }).catch(res => {
        console.error('BsyAlertQYWorkConfig',res);
    })

export default BsyAlertQYWorkConfig